import moment from "moment"
const today = moment()
const earlier = moment().add(-30, "days")


const monthComparisonStart = moment().add(-1, "days").add(-1, "months").startOf("month")
const monthComparisonEnd = moment().add(-1, "days")

export default {
  strategy: null,
  range: { start: earlier.toDate(), end: today.toDate() },
  dimension: "Date",
  secondaryDimension: "Domain",
  isLoading: true,
  dashboard: {
    isLoading: true,
    statistics: []
  },
  monthComparison:
  {
    isLoading: true,
    range: { start: monthComparisonStart.toDate(), end: monthComparisonEnd.toDate() },
    currentMonth: { name: "ThisMonth", data: [] },
    previousMonth: { name: "LastMonth", data: [] }
  },
  dimensions: [
    {
      title: "Time",
      group: [
        { text: "Date", value: "Date", percentageView: false },
        { text: "Day of week", value: "DayOfWeek", percentageView: false },
        { text: "Hour of day", value: "HourOfDay", percentageView: false }
      ]
    },
    {
      title: "Placement",
      group: [
        { text: "Ad size", value: "BannerSize", percentageView: false },
        { text: "Ad type", value: "BannerId", percentageView: false },
        { text: "Application Name", value: "AppName", percentageView: false },
        { text: "Deal", value: "Deal", percentageView: false },
        { text: "Domain", value: "Domain", percentageView: false },
        { text: "Inventory Type", value: "InventoryType", percentageView: false },
        { text: "Position On Page", value: "Position", percentageView: false }
      ]
    },
    {
      title: "Geo",
      group: [
        { text: "City", value: "City", percentageView: false },
        { text: "Country", value: "Country", percentageView: false },
        { text: "Postal Code", value: "PostalCode", percentageView: false },
        { text: "Region", value: "Region", percentageView: false }
      ]
    },
    {
      title: "Device",
      group: [
        { text: "Browser", value: "Browser", percentageView: false },
        { text: "Device Type", value: "DeviceType", percentageView: false },
        { text: "Operating System", value: "Os", percentageView: false }
      ]
    },
    {
      title: "Context",
      group: [
        { text: "Branches", value: "RetailBranches", percentageView: false },
        { text: "Category", value: "Category", percentageView: false },
        { text: "Sub Category", value: "SubCategory", percentageView: false }
      ]
    },
    {
      title: "Digital Audience",
      group: [
        { text: "Age", value: "Age", percentageView: true },
        { text: "Child Age", value: "ChildAge", percentageView: true },
        { text: "Child Gender", value: "ChildGender", percentageView: true },
        { text: "Education", value: "Education", percentageView: true },
        { text: "Employment", value: "Employment", percentageView: true },
        { text: "Gender", value: "Gender", percentageView: true },
        { text: "Home Owner", value: "HomeOwner", percentageView: true },
        { text: "Household Income", value: "HouseholdIncome", percentageView: true },
        { text: "Mosaic", value: "mosaic", percentageView: true },
        { text: "Property Value", value: "PropertyValue", percentageView: true }
      ]
    }
  ]
}
